import '../styles/component.scss';

const DEFAULT = {
	containerId: 'rstuning',
	styleSelectId : 'rstuning_styles',
	timeoutChanageStylesDelay : 250,
	timeoutChanageStylesId : 0,
};


export class Tuning
{
	static instance = null;
	container = null;
	elements = [];

	colorMacrosContent = '';
	colorMacrosCompiled = '';
	macrosList = {};

	constructor(options = {})
	{
		this.options = {...DEFAULT, ...options};

		document.addEventListener('DOMContentLoaded', this.init.bind(this));
	}

	init()
	{
		this.container = document.getElementById(this.options.containerId);

		if (!this.container)
			return;

		this.elements = [...this.container.querySelectorAll('[data-macros]')];

		if (this.elements && this.elements.length > 0)
		{
			for (let i = 0; i < this.elements.length; i++)
			{
				this.setMacros(this.elements[i].getAttribute('data-macros'), this.elements[i].value);

				if (this.elements[i].getAttribute('data-tuning-color-macros'))
				{
					this.setMacros(this.elements[i].getAttribute('data-tuning-color-macros'), this.elements[i].value);
				}
			}
		}
	}

	generateCss()
	{
		this.replaceMacros();
		this.innerStyles();

		return true;
	}

	getReadyMacros()
	{
		var event = new CustomEvent('rs.tuning.onBeforeGetReadyMacros', {'detail' : {'macrosList': this.macrosList}});
		document.dispatchEvent(event);

		return this.macrosList;
	}

	setColorMacrosContent(content)
	{
		this.colorMacrosContent = content;

		return true;
	}

	getColorMacrosContent()
	{
		return this.colorMacrosContent;
	}

	replaceMacros()
	{
		var content = this.getColorMacrosContent(),
			macrosList = this.getReadyMacros();

		for (let key1 in macrosList)
		{
			content = content.replace(new RegExp('#' + key1 + '#', 'g'), macrosList[key1]);
		}

		this.setColorMacrosCompiled(content);

		return true;
	}

	innerStyles()
	{
		clearTimeout(this.options.timeoutChanageStylesId);

		this.options.timeoutChanageStylesId = setTimeout(() => {
			document.getElementById(this.options.styleSelectId).innerHTML = ''
				+ '<style>' + this.getColorMacrosCompiled() + '</style>';
		}, this.options.timeoutChanageStylesDelay);

		return true;
	}

	setColorMacrosCompiled(content)
	{
		this.colorMacrosCompiled = content;

		return true;
	}

	getColorMacrosCompiled()
	{
		return this.colorMacrosCompiled;
	}

	setMacros(macrosName, value)
	{
		this.macrosList[macrosName] = value;

		return true;
	}
}
